<template>
    <b-modal
        id="add-rubric-section"
        :title="$t('rubrics.add_rubric')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        @ok="onOk"
        @show="show"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <div class="rubric-add-section">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    variant="danger"
                    show>
                    {{ $t('rubrics.the_title_field_cannot_be_empty') }}
                </b-alert>
            </div>

            <b-form-group
                class="rubric-title-group"
                :label="$t('common.title')"
                label-for="rubric-title-input">
                <b-form-input
                    id="rubric-title-input"
                    v-model="title"
                    :placeholder="$t('common.title')"></b-form-input>
            </b-form-group>

            <b-form-group
                class="rubric-weight-group"
                :label="$t('rubrics.weight')"
                label-for="rubric-weight-input">
                <b-form-input
                    id="rubric-weight-input"
                    v-model="weight"
                    :placeholder="$t('rubrics.weight')"></b-form-input>
            </b-form-group>
        </div>

        <div>
            {{ $t('rubrics.copy_columns') }}
            <design-2021-apprentice-multiselect-component
                v-model="value"
                :options="this.rubricIn.rubric_sections"
                label="title"
                track-by="title"
                :multiple-select="false">
            </design-2021-apprentice-multiselect-component>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-add-section-modal-component',
    props: ['rubricIn'],
    data() {
        return {
            title: '',
            weight: 1,
            rubric: this.rubricIn,
            hasError: false,
            value: null,
        };
    },
    //options van hierboven
    methods: {
        onOk(bvModalEvt) {
            if (this.title === '') {
                bvModalEvt.preventDefault();
                this.hasError = true;
                return;
            }

            let section_id = null;

            if (this.value !== null) {
                section_id = this.value.id;
            }

            const data = {
                title: this.title,
                weight: this.weight,
                section_id: section_id,
            };

            this.alert.saving();

            this.axios.post(this.routes.addRubricSection(this.rubricIn.id), data).then(
                (response) => {
                    this.rubricIn.addRelation('rubric_sections', response.data);
                    this.title = '';
                    this.weight = 1;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show() {
            this.hasError = false;
            this.value = null;
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .rubric-add-section {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .errors {
            flex: 1 0 100%;
        }

        .rubric-title-group {
            width: calc(75% - 15px);
        }

        .rubric-weight-group {
            width: calc(25% - 15px);
        }
    }
}
</style>
